import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './Navigation.css';
import api from '../utils/axios';
import logo from '../assets/logo.png'; // Adjust the path to your logo file
import MenuIcon from '@mui/icons-material/Menu';
import { Drawer, List, ListItem, ListItemText, IconButton, ListSubheader, Collapse } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { logout } from '../redux/authSlice';
import { fetchUserWithProfile } from '../utils/auth';


const Navigation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [datasetsEnabled, setDatasetsEnabled] = useState(false);
  useEffect(() => {
    api.get('datasets/capabilities/').then(({ data }) => setDatasetsEnabled(data.enabled)).catch(() => setDatasetsEnabled(false));
  }, []);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [inventoryOpen, setInventoryOpen] = useState(false);
  const [assayOpen, setAssayOpen] = useState(false);
  // const userProfile = useSelector((state) => state.auth.user);
  const [user, setUser] = useState(null);

  const loadUserProfile = async () => {
    const userFromLocalStorage = JSON.parse(localStorage.getItem('user'));    
    if (userFromLocalStorage != null) {
      let userWithProfile = await fetchUserWithProfile(userFromLocalStorage.pk)
      setUser(userWithProfile);
    }
    console.dir(userFromLocalStorage)
  }
  
  useEffect(() => {
    loadUserProfile();
  }, []);
  
  const handleLogout = () => {
    dispatch(logout());
    navigate('/');
  };

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const toggleInventory = () => {
    setInventoryOpen(!inventoryOpen);
  };

  const toggleAssay = () => {
    setAssayOpen(!assayOpen);
  };

  return (
    <nav className="navbar">
      <ul className="navbar-links">
        <li>
        <div className="navbar-logo">
          <a href="/home"><img src={logo} alt="Logo" /></a>
        </div>
        </li>
        <li className="dropdown">
          <a href="/inventory/live-tracking">Inventory Management</a>
          <div className="dropdown-content">
            <a href="/inventory/live-tracking">Live Tracking</a>
            <a href="/configuration/Inventory">Inventory Configuration</a>
            <a href="/inventory/deposition">Inventory Deposition</a>
            <a href="/inventory/recent-activity">Recent Activity</a>
            <a href="/inventory/search">Search</a>
            <a href="/inventory/reports">Reports</a>
          </div>
        </li>
        <li className="dropdown">
          <a href="/assay/live-tracking">Assay Management</a>
          <div className="dropdown-content">
            <a href="/assay/live-tracking">Live Tracking</a>
            <a href="/configuration/Assay">Assay Configuration</a>
            <a href="/assay/deposition">Assay Deposition</a>
            <a href="/assay/recent-activity">Recent Activity</a>
            <a href="/assay/search">Search</a>
            <a href="/assay/reports">Reports</a>
          </div>
        </li>
        {datasetsEnabled && <li><a href="/datasets">Dataset Explorer</a></li>}
      </ul>
      <ul className="navbar-links">
        {user !== null && user.profile.type === 'admin' && (
        <li><a href="/admin/programs">Programs</a></li>
        )}
        {user !== null && user.profile.type === 'admin' && (
        <li><a href="/admin/organizations">Organizations</a></li>
        )}
        {user !== null && user.profile.type === 'admin' && (
        <li><a href="/admin/users">Users</a></li>
        )}
        <li><a href="/profile">Profile</a></li>
        <li><button className="logout-button" onClick={handleLogout}>Log out</button></li>
      </ul>
      <div className="hamburger-menu">
        <IconButton edge="start" color="inherit" aria-label="menu" onClick={toggleDrawer(true)}>
          <MenuIcon />
        </IconButton>
        <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
          <List>
            {datasetsEnabled && <ListItem button component="a" href="/datasets"><ListItemText primary="Dataset Explorer" /></ListItem>}
            <ListItem button onClick={toggleInventory}>
              <ListItemText primary="Inventory" />
              {inventoryOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={inventoryOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem button onClick={toggleDrawer(false)} component="a" href="/inventory/live-tracking">
                  <ListItemText primary="Live Tracking" />
                </ListItem>
                <ListItem button onClick={toggleDrawer(false)} component="a" href="/inventory/recent-activity">
                  <ListItemText primary="Recent Activity" />
                </ListItem>
                <ListItem button onClick={toggleDrawer(false)} component="a" href="/inventory/search">
                  <ListItemText primary="Search" />
                </ListItem>
                <ListItem button onClick={toggleDrawer(false)} component="a" href="/inventory/reports">
                  <ListItemText primary="Reports" />
                </ListItem>
              </List>
            </Collapse>
            <ListItem button onClick={toggleAssay}>
              <ListItemText primary="Assay" />
              {assayOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={assayOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem button onClick={toggleDrawer(false)} component="a" href="/assay/live-tracking">
                  <ListItemText primary="Live Tracking" />
                </ListItem>
                <ListItem button onClick={toggleDrawer(false)} component="a" href="/assay/configurations">
                  <ListItemText primary="Manage Assay Configurations" />
                </ListItem>
                <ListItem button onClick={toggleDrawer(false)} component="a" href="/assay/recent-activity">
                  <ListItemText primary="Recent Activity" />
                </ListItem>
                <ListItem button onClick={toggleDrawer(false)} component="a" href="/assay/search">
                  <ListItemText primary="Search" />
                </ListItem>
                <ListItem button onClick={toggleDrawer(false)} component="a" href="/assay/reports">
                  <ListItemText primary="Reports" />
                </ListItem>
              </List>
            </Collapse>
            <ListItem button onClick={toggleDrawer(false)} component="a" href="/profile">
              <ListItemText primary="Profile" />
            </ListItem>
            <ListItem button onClick={handleLogout}>
              <ListItemText primary="Log out" />
            </ListItem>
          </List>
        </Drawer>
      </div>
    </nav>
  );
};

export default Navigation;
